<template>
  <div class="plugin-container">
    <BlockHead />
    <BlockCreationSteps />
    <BlockMasterSpecifications @openVideoPopup="videoPopup=true" />
    <BlockActionTime />

    <PopupVideo v-model="videoPopup" />
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"

import PopupVideo from "./components/PopupVideo"
import BlockHead from "./components/BlockHead"
import BlockCreationSteps from "./components/BlockCreationSteps"
import BlockMasterSpecifications from "./components/BlockMasterSpecifications"
import BlockActionTime from "./components/BlockActionTime"

export default {
  name: "LandingPlugin",
  components: {
    bimContainer,

    PopupVideo,
    BlockHead,
    BlockCreationSteps,
    BlockMasterSpecifications,
    BlockActionTime
  },
  data() {
    return {
      videoPopup: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.plugin-container {
  background-color: #f8f8f8;
}
</style>
